import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_CANCELLATION_REASONS } from "api/Service";

export const CANCELLATION_REASONS_QUERY_KEY = "cancellationReasons";

export const useCancellationReasons = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: [CANCELLATION_REASONS_QUERY_KEY, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_CANCELLATION_REASONS}`
      );

      return Array.isArray(response.data) ? response.data : [];
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
